import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { authService } from './services/authService'
import { ToastProvider } from './components/UI/Toast'
import ErrorBoundary from './components/ErrorBoundary'
import App from './App.tsx'
import './index.css'

// Render unconditionally.
//
// This used to sit inside `authService.initialize().then(...)`, after an
// awaited `handleRedirectPromise()`. That gate was both redundant and unsafe:
//
//   - Redundant, because MsalProvider already calls `initialize()` and then
//     `handleRedirectPromise()` itself and publishes the result as
//     `inProgress` (which AuthWrapper now consumes). msal-browser also warns
//     that a second `handleRedirectPromise` call returns a cached promise and
//     can suppress the events that move `inProgress` off 'startup'.
//   - Unsafe, because a rejection from either call left `.catch` logging to a
//     console nobody reads while `render()` was never reached — an empty
//     #root, permanently. That is the blank screen in RE-166321.
//
// Nothing here may await anything: whatever happens to auth, something renders.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <MsalProvider instance={authService.getInstance()}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </MsalProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
